import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { Checkbox, Input, Popover } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';
const { TextArea } = Input;
import UIValue from './uiValue';
import UIValidation from './uiValidation';
import UIText from './uiText';
function CheckboxFieldComponent(props) {
    const [isChecked, setIsChecked] = useState(props.isChecked !== false);
    const [value, setValue] = useState(props.value || '');
    useEffect(() => {
        setValue(props.value || '');
    }, [props.value]);
    useEffect(() => {
        setIsChecked(props.isChecked !== false);
    }, [props.isChecked]);
    const handleToggle = (e) => {
        const checked = e.target.checked;
        setIsChecked(checked);
        // Call the onToggle callback if provided
        if (props.onToggle) {
            props.onToggle(checked);
        }
    };
    const handleChange = (event) => {
        setValue(event.target.value);
        props.onChange(event);
    };
    return (_jsxs("div", { className: "flex items-center gap-2 mb-4", style: props.styling, children: [_jsx(Checkbox, { checked: isChecked, onChange: handleToggle }), _jsxs("label", { className: ` text-sm text-gray-800`, style: { width: props.titleWidth }, children: [props.title, "  ", props.text && (_jsx(Popover, { content: props.text, trigger: "click", overlayStyle: { width: 300 }, children: _jsx(InfoCircleOutlined, { style: { cursor: 'pointer' } }) }))] }), props.fieldType === 'text' && (_jsx(Input, { className: "ml-2", placeholder: props.placeholder, value: value, onChange: handleChange, disabled: !isChecked, readOnly: props.readonly, style: { width: props.inputWidth } })), props.fieldType === 'textArea' && (_jsx(TextArea, { className: "ml-2", placeholder: props.placeholder, value: value, onChange: handleChange, disabled: !isChecked, readOnly: props.readonly, style: { width: props.inputWidth } }))] }));
}
export default class UICheckboxField extends UIValue {
    title;
    text;
    placeholder;
    inputWidth;
    titleWidth;
    fieldType;
    style;
    readonly;
    isChecked;
    onChange;
    onToggle;
    constructor(s) {
        super(s);
        if ('title' in s) {
            this.title = this.getProperty('title');
        }
        else if ('label' in s) {
            this.title = s.label;
        }
        else {
            this.title = '';
        }
        if ('text' in s) {
            this.text = new UIText(s);
        }
        else if ('tooltip' in s) {
            this.text = new UIText({ text: s.tooltip, style: s.style || {} });
        }
        this.placeholder = this.getProperty('placeholder', '');
        this.inputWidth = this.getProperty('inputWidth', '');
        this.titleWidth = this.getProperty('titleWidth', '120px');
        this.fieldType = this.getProperty('fieldType', 'text');
        this.style = this.getProperty('style', '');
        this.readonly = this.getProperty('readonly', false);
        this.isChecked = this.getProperty('isChecked', true);
    }
    getComponent() {
        const onChange = (event) => {
            this.value = event.target.value;
            this.error = undefined;
            this.onChange?.(event);
        };
        const onToggle = (checked) => {
            this.isChecked = checked;
            this.error = undefined;
            this.onToggle?.(checked);
        };
        const text = this.text !== undefined ? this.text.getComponent() : null;
        const props = {
            title: this.title,
            text: text,
            placeholder: this.placeholder,
            inputWidth: this.inputWidth,
            titleWidth: this.titleWidth,
            fieldType: this.fieldType,
            onChange: onChange,
            onToggle: onToggle,
            value: this.value,
            readonly: this.readonly,
            styling: this.style,
            isChecked: this.isChecked,
        };
        return (_jsx(UIValidation, { error: this.error, children: _jsx(CheckboxFieldComponent, { ...props }) }));
    }
}
//# sourceMappingURL=uiCheckboxField.js.map